import React from 'react';
import { inject, observer } from "mobx-react";


const DeliveryOptionsTextTurkish = ({feathersStore})=> {
  return(
   <div className="terms-text">
       <h2>Teslimat ve Kargo</h2>
      <p>
        Mağazamızda müşterilerimize en iyi hizmeti vermek için elimizden geleni yapıyoruz. Ürünlerinizi telefonla veya web sitemiz üzerinden uzaktan sipariş edebilirsiniz. Aşağıda ürünlerimizi gönderme ve teslim alma konusundaki en yaygın iki yöntem bulunmaktadır.
      </p>    
      <h2>
        Mağazamızdan teslim alma
      </h2>
      <p>
        Alışverişlerinizi {feathersStore.settings?.address} adresindeki mağazamızdan teslim alabilirsiniz.
      </p>
      <h2>
        Adresinize teslimat
      </h2>
      <p>
        Siparişinizi belirttiğiniz adrese getirmeyi taahhüt ediyoruz.
      </p>
    </div>
  )
}
    
export default inject('feathersStore')(observer(DeliveryOptionsTextTurkish));